<template>
    <div class="admin-statistic">
        <StatisticDashboard />
    </div>
</template>

<script>
// @ is an alias to /src
import StatisticDashboard from "@/components/StatisticDashboard";

export default {
    name: "AdminStatistic",
    components: {
        StatisticDashboard,
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    }
};
</script>
<style scoped>
</style>